import Api from '@/api'

export default {
  state: {report_data: {headers: [], rows: []}},
  actions: {
    async LOAD_REPORTS_LIST({}) {
      try {
        const res = await Api.load_reports_list()
        const {status, data} = res
        if (status === 200) {
          return data.reports
        } else {
          throw `Load list of reports status: ${status}`
        }
      } catch (err) {
        throw `Load dashboard: ${err}`
      }
    },
    async LOAD_REPORT_DATA({commit}, type) {
      console.log('LOAD_REPORT_DATA:', type)
      try {
        const res = await Api.load_report_data(type)
        const {status, data} = res
        if (status === 200) {
          commit('SET_REPORT_DATA', data)
        } else {
          throw `Load report data status: ${status}`
        }
      } catch (err) {
        throw `Load dashboard: ${err}`
      }
    }
  },
  mutations: {
    SET_REPORT_DATA(state, report_data) {
      //console.log({report_data: report_data.data})
      state.report_data = {...report_data.data}
    }
  },
  getters: {}
}
